// eslint-disable-next-line
import { GetOpenedAlertByCourse, getLocalWeather, getMicroWeather, getActiveTasks, getPrecipitationTotals, getStationMinMaxTemps } from '@/api/index';
import { Mixin } from 'gw-js-lib';

export default {
  namespaced: true,
  state: { /* = data */
    localWeather: {},
    microWeather: {},
    precipitationTotals: {},
    alerts: [],
    tasks: [],
    selectedAlert: {},
    loading: {
      localWeather: false,
      microWeather: false,
      precipitationTotals: false,
      alerts: false,
      tasks: false,
      dailyTemps: false,
    },
    paginations: {
      tasks: {
        page: 1,
        rows: 100,
        order_by: 'orden asc, time_updated desc',
        filters: {
          // status: null,
        },
      },
    },
    dailyTemps: {},
  },

  getters: { /* = Computed properties, perfects to filter data an execute some calculation */
  },


  actions: { /* = Methods */

    async loadWeather({ commit }) {
      commit('setLoading', {
        localWeather: true,
        microWeather: true,
      });

      getLocalWeather().then((localWeather) => {
        commit('setLocalWeather', localWeather);
        commit('setLoading', {
          localWeather: false,
        });
      });

      getMicroWeather().then((microWeather) => {
        commit('setMicroWeather', microWeather);
        commit('setLoading', {
          microWeather: false,
        });
      });
    },

    async loadPrecipitationTotals({ commit }) {
      commit('setLoading', { precipitationTotals: true });

      getPrecipitationTotals().then((precipitationTotals) => {
        if(precipitationTotals){
          commit('setPrecipitationTotals', precipitationTotals);
        }
        commit('setLoading', {
          precipitationTotals: false,
        });
      });

    },

    async loadAlerts({ commit }) {
      commit('setLoading', { alerts: true });

      await GetOpenedAlertByCourse().then((response) => {
        commit('setAlerts', response.alerts);
      }).finally(() => {
        commit('setLoading', { alerts: false });
      });
    },
    
    async loadTasks({ commit, state }) {
      commit('setLoading', { tasks: true });

      await getActiveTasks( ).then((tasks) => {
        commit('setTasks', tasks);
      }).finally(() => {
        commit('setLoading', { tasks: false });
      });
    },

    async loadDailyTemps({ commit, state }) {
      commit('setLoading', { dailyTemps: true });

      await getStationMinMaxTemps(state.microWeather[0].station.device_sn).then((response) => {
        console.log('DailyTemps', response);
        commit('setDailyTemps', response[0]);
      }).finally(() => {
        commit('setLoading', { dailyTemps: false });
        console.log('Final state', state.dailyTemps);
      });
    },

  },

  mutations: { /* Mutations are responsible to change the state */
    setLocalWeather(state, localWeather) {
      state.localWeather = localWeather;
    },

    setMicroWeather(state, microWeather) {
      state.microWeather = microWeather;
    },

    setPrecipitationTotals(state, precipitationTotals) {

      for(let weather of state.microWeather){
        weather.precipitation_totals = {month: 0, quarter: 0, year: 0};

        for(let precipitation of precipitationTotals){

          if(precipitation.station.station_id == weather.station.station_id){
            
            weather.precipitation_totals = {
              week: precipitation.week_total,
              month: precipitation.month_total,
              quarter: precipitation.quarter_total,
              year: precipitation.year_total
            };
            
            break;
          }
          
        }
      }

      state.precipitationTotals = precipitationTotals;
    },

    setDailyTemps(state, dailyTemps) {
      state.dailyTemps = dailyTemps
    },

    setAlerts(state, alerts) {
      state.alerts = alerts;
      setTimeout(()=> { Mixin.methods.G_triggerResizeEven(); }, 10);
    },
    setTasks(state, tasks) {
      state.tasks = tasks;
      setTimeout(()=> { Mixin.methods.G_triggerResizeEven(); }, 10);
    },
    setCourseId(state, CourseId) {
      state.paginations.tasks.filters.course_id = CourseId;
    },
    setSelectedAlert(state, alert) {
      state.selectedAlert = alert;
    },
    setLoading(state, loading) {
      state.loading = { ...state.loading, ...loading };
    },

  },

};
